import { sortBy } from 'lodash'
import { createSelector } from 'reselect'

// Other selector dependencies
import { allCustomTemplatesSelector, templatesSelector } from './templatesFirstOrder'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').CustomTemplate} CustomTemplate
 * @typedef {import('../index').BuiltInTemplate} BuiltInTemplate
 * @typedef {CustomTemplate | BuiltInTemplate} Template
 */

export const customTemplatesSelector = allCustomTemplatesSelector

const templateIdSelector = (state, templateId) => templateId
/**
 * @type {function(PlottrState, String): (CustomTemplate | BuiltInTemplate | Null)}
 */
export const templateByIdSelector = createSelector(
  templatesSelector,
  customTemplatesSelector,
  templateIdSelector,
  (templates, customTemplates, templateId) => {
    const finder = ({ id }) => id === templateId
    return templates.find(finder) || customTemplates.find(finder) || null
  }
)
/**
 * @type {function(PlottrState): (function(String): (Template | CustomTemplate | Null))}
 */
export const templateByIdFnSelector = createSelector(
  templatesSelector,
  customTemplatesSelector,
  (templates, customTemplates) => (templateId) => {
    const finder = ({ id }) => id === templateId
    return templates.find(finder) || customTemplates.find(finder) || null
  }
)

/**
 * @param {PlottrState} _state
 * @param {String} type
 * @return {String}
 */
const templateTypeSelector = (_state, type) => type
/**
 * @param {PlottrState} _state
 * @param {any} _
 * @param {String} searchTerm
 * @return {String}
 */
const templateSearchTermSelector = (_state, _, searchTerm) => searchTerm
/**
 * @type {function(PlottrState, String, String): Array<CustomTemplate>}
 */
export const filteredSortedCustomTemplatesSelector = createSelector(
  customTemplatesSelector,
  templateTypeSelector,
  templateSearchTermSelector,
  (templates, type, searchTerm) => {
    return sortBy(
      templates.filter((t) => {
        if (searchTerm && searchTerm.length > 1) {
          return (t.name ?? '').toLowerCase().includes(searchTerm) && t.type == type
        } else if (type) {
          return t.type == type
        } else {
          return true
        }
      }),
      'name'
    )
  }
)
